<template>
  <div v-if="isLoading" class="global-loader-overlay">
    <div class="global-loader-content">
      <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Загрузка...</span>
      </div>
      <p class="mt-3 text-muted">Загрузка...</p>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "GlobalLoader",
  data() {
    return {
      isLoading: false,
      hideTimer: null
    }
  },
  mounted() {
    // Показываем лоадер при начале навигации
    router.beforeEach((to, from) => {
      // Не показываем лоадер при первом запуске
      if (from.name === null) {
        return;
      }
      this.isLoading = true;

      // Принудительно скрываем через 3 секунды (защита от зависания)
      if (this.hideTimer) clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
        this.isLoading = false;
      }, 3000);
    });

    // Скрываем после завершения навигации
    router.afterEach((to, from) => {
      // Не скрываем при первом запуске
      if (from.name === null) {
        return;
      }
      if (this.hideTimer) clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => {
        this.isLoading = false;
      }, 200);
    });

    // Скрываем при ошибке навигации
    router.onError(() => {
      if (this.hideTimer) clearTimeout(this.hideTimer);
      this.isLoading = false;
    });
  },
  beforeUnmount() {
    if (this.hideTimer) clearTimeout(this.hideTimer);
  }
}
</script>

<style scoped>
.global-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.global-loader-content {
  text-align: center;
}

.spinner-border {
  animation: spinner-border 1s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>